import PropTypes from "prop-types";
import { memo } from "react";
import LuggageSummary from "app/pages/Booking/Quotation/Flight/LuggageSummary/LuggageSummary";

import "./MyFlightDetail.scss";
import Itinerary from "app/pages/.shared/Itinerary";
import { getSupplierClass } from "app/utils/utils";

const MyFlightDetail = ({
	flight = {},
	luggageMaxCount = 0,
	lugaggeCount,
	maxWeightPerCheckedBaggage,
	flightOptions = {},
	bookingCabinLuggage = {},
}) => {
	const flightBagageOption =
		flightOptions?.flightBagageOption || flight?.flightOptions?.flightBagageOption;
	const isBaggageIncluded = flightBagageOption?.included;
	const isBaggageCanBeBooked = flightBagageOption?.canBeBooked;
	const hideSupplierClass = !isBaggageIncluded && isBaggageCanBeBooked;

	return (
		<div className="my-flight-detail">
			<div className="itinerary">
				<Itinerary
					inbound={flight.inbound}
					outbound={flight.outbound}
					disableDetails={true}
					displayRouteDetails={true}
					transportationType={flight?.type}
					{...!hideSupplierClass && {
						outboundSupplierClass: getSupplierClass(flight?.outbound?.legs),
						inboundSupplierClass: getSupplierClass(flight?.inbound?.legs),
					}}
				/>
			</div>

			<LuggageSummary
				luggageMaxCount={luggageMaxCount}
				flight={flight}
				flightOptions={flightOptions}
				bookingLuggageCount={lugaggeCount}
				bookingCabinLuggage={bookingCabinLuggage}
				hideAddLuggageButton
				transportationType={flight.type}
				maxWeightPerCheckedBaggage={maxWeightPerCheckedBaggage}
			/>
		</div>
	);
};

MyFlightDetail.propTypes = {
	flight: PropTypes.object,
	luggageMaxCount: PropTypes.number,
	lugaggeCount: PropTypes.number,
	flightOptions: PropTypes.object,
	maxWeightPerCheckedBaggage: PropTypes.number,
	bookingCabinLuggage: PropTypes.object,
};

export default memo(MyFlightDetail);
